/**
 * Cookie name for storing the offer ID override
 * @type {string}
 */
export const OFFER_ID_COOKIE_NAME = 'bt-offer-id';

/**
 * URL parameter name for offer ID override
 * @type {string}
 */
export const OFFER_ID_URL_PARAM = 'btoffid';
